export interface AccountingQBOItemProps {
  qboItemId: number | null;
  qboItemName: string | null;
}

export class AccountingQBOItem {
  private readonly _qboItemId: number | null;
  private readonly _qboItemName: string | null;

  constructor(props: AccountingQBOItemProps) {
    this._qboItemId = props.qboItemId ?? null;
    this._qboItemName = props.qboItemName ?? null;
  }

  public get qboItemId(): number | null {
    return this._qboItemId;
  }

  public get qboItemName(): string | null {
    return this._qboItemName;
  }

  public static fromJson(props: AccountingQBOItemProps): AccountingQBOItem {
    return new AccountingQBOItem(props);
  }
}
